export const isTablet = (): boolean => {
  const screenWidth = window.screen.width
  return screenWidth > 767
}
